<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_Parts"  :title-link-class="textColors" :title-item-class="textColors" active >
            
          </b-tab>

        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'
//import TreeComponent from "@/components/shared/TreeComponent";


//import FormTableComponent from '@/components/shared/FormTableComponent'

export default {
  name: "Content",
  components: {
     //TreeComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      selected: 'update',
      options: [
        { text: 'Update category', value: 'update' },
        { text: 'New category', value: 'new' },
        
      ],
      optionsCisCompatible: [
        { text: 'Orcad CIS compatible', value: 'true' },
        { text: 'Generic', value: 'false' },
      ],
      cisCompatible: true,
      file: null,
      categoriesData: {},
      categoryName:"",
      categoryNameUpdate: "",
      partNumberTemplate: "",
      partNumberTemplateUpdate: this.partNumberTemplateTree,
      cisCompatibleUpdate: false,
      disabled: "disabled",
      inputStatus: null,

      reloadTree: false,
      editCategories: true,
      objectData:{},
      objAlertSuccess: {
         text: this.lang.alert_success_create_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertError:{
        text:this.lang.alert_error_create_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      objAlertSuccessUpdate: {
         text: this.lang.alert_success_update_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertErrorUpdate:{
        text:this.lang.alert_error_update_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      
    }
  },
  computed: {
    ...mapGetters({

      formDetailsData: 'formDetailsData',
      elementCategory: 'elementCategory',
      //projectCategoriesData: 'projectCategoriesData',
      selectedTreeItemObject:'selectedTreeItemObject',
    }),
    categoryId(){
      return this.$store.getters.selectedTreeItemObject.categoryId
    },
    image(){
      return this.$store.getters.selectedTreeItemObject.image;
    },
    categoryNameUpdateTree(){
      return this.$store.getters.selectedTreeItemObject.name;
    },
    partNumberTemplateTree(){
      return this.$store.getters.selectedTreeItemObject.partNumberTemplate;
    },
    cisCompatibleParam(){
      return this.$store.getters.selectedTreeItemObject.cisCompatible;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }
  },
  created () {
    

    this.displayImageCategory();

  },

  updated() {
        
  },
  watch: {
    categoryId: function(newVal, oldVal) {
      

      this.displayImageCategory();
      
    },
    projectCategoriesData: function(newVal, oldVal) {
     this.categoriesData = JSON.parse(newVal.data);


    },
    categoryName: function(newVal, oldVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }

      
    },
    categoryNameUpdateTree: function(newVal, oldVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }
      if(newVal == "All components"){
        this.disabled = true;
      }else{
        this.disabled = false;
      }
      
      this.categoryNameUpdate = newVal;
    },
    partNumberTemplateTree: function(newVal, oldVal){
      
      
      this.partNumberTemplateUpdate = newVal;
    },
    cisCompatibleParam: function(newVal, oldVal){
      
      
      this.cisCompatibleUpdate = newVal;
    },
  },
  methods:{
    
    displayImageCategory(image = this.image){

      if (image != undefined){
        let vue = this;

        const obj = {
          fileName: image
        }
        

        
        this.$store.dispatch("getImage", obj)
        .then((result) => {
          console.log(result)
          
            
            vue.$nextTick(function () {

              let img = document.getElementById("image__category");
              
              img.src = "";
              img.src = URL.createObjectURL(result);
              

              
            })
            
            
        
        
        })


      }
      

    },
    createCategory(){
      
      if (this.categoryName != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }
        let obj = {
          parentId: this.selectedTreeItemObject.categoryId,
          fullPath: this.selectedTreeItemObject.category + "\\" + this.categoryName,
          objAlertSuccess: this.objAlertSuccess,
          objAlertError: this.objAlertError,
          file: file,
          template: this.partNumberTemplate,
          cisCompatible: this.cisCompatible
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createCategory", obj)
           .then((result)=>{
              console.log(result.data)
              if(result.data == 1){

                vue.categoryName = "";
                vue.inputStatus = null;

                
                vue.reloadTree= !vue.reloadTree;
              }
        })


      }else{

      }

    },
    
    updateCategory(){
      if (this.categoryNameUpdate != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }

        let path = this.selectedTreeItemObject.category;
        let temp = path.split("\\")
        

        let lei = temp.length;
        temp[lei - 1] = this.categoryNameUpdate
        

        let newPath = "";
        for(let i = 0; i < lei; i++ ){
          newPath += temp[i];
          if (i < lei - 1){
            newPath += "\\";
          }
        }
        

        let obj = {
          categoryId: this.selectedTreeItemObject.categoryId,
          fullPath: newPath,
          objAlertSuccess: this.objAlertSuccessUpdate,
          objAlertError: this.objAlertErrorUpdate,
          file: file,
          template: this.partNumberTemplateUpdate,
          cisCompatible: this.cisCompatibleUpdate
        }
        console.log(obj)
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateCategory", obj)
           .then((result)=>{
              console.log(result.data)
              if(result.data != null){

                vue.reloadTree= !vue.reloadTree;

                vue.displayImageCategory(result.data.fileId);
              }
        })


      }else{

      }
    }

  },
  
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .btn{
    margin-left: 5px;

  }
  .content .input-category-name{
     width: 100%;
  }
  .content .input-category-name-update{
     width: 100%;
  }
  .img-fluid {
    max-width: 200px;
    
  }
  .category-image{
    max-width: 200px;
  } 
  

  .info-template{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/UL/Middle/Content/Content.vue